import API, { defaultHeaders } from '../';

const requestPasswordChange = async (payload = {}) => {
  const headers = Object.assign({}, defaultHeaders);
  return fetch(`${API}/user/forgot-password`, {
    method: 'put',
    headers,
    body: JSON.stringify(payload),
  });
};

export default requestPasswordChange;
